angular.module('ikeweb.user').controller('CreditCardController', ['functional', '$filter', '$locale', 'creditCardService',

    function(f, $filter, $locale, CreditCardService) {

        function pad(s, p) {

            if (p - s.length <= 0) {
                return s;
            }

            return pad('0' + s, p);
        }


        function yearsFromNow() {
            var thisYear = moment().year();
            return function(additionalYears) {
                var year = thisYear + additionalYears + '';
                return {
                    label: year,
                    value: year
                };
            };
        }

        function monthsFromNow() {
            var now = moment();
            return function(additionalMonths) {
                var month = now.months(additionalMonths).toISOString();
                var n = pad(additionalMonths + 1 + '', 2);
                return {
                    label: $filter('date')(month, 'MMM') + ' (' + n + ')',
                    value: n
                };
            };
        }

        var monthsPerLocale = {};

        function getMonths() {
            if (!monthsPerLocale[$locale.id]) {
                monthsPerLocale[$locale.id] = f.range(12).map(monthsFromNow());
            }
            return monthsPerLocale[$locale.id];
        }

        var years = f.range(10).map(yearsFromNow());

        function getYears() {
            return years;
        }

        this.getMonths = getMonths;
        this.getYears = getYears;
        this.isValidCardNumber = CreditCardService.isValidCardNumber;
        this.getCardNumberPattern = CreditCardService.getCardNumberPattern;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit-card-form/credit.card.form.controller.js
// module id = 491
// module chunks = 0